// src/shared/models/survey-response-status.enum.ts
export enum SurveyResponseStatus {
    NEW = 'NEW',
    IN_REVIEW = 'IN_REVIEW',
    QUOTATION_SENT = 'QUOTATION_SENT',
    WAITING_RESPONSE = 'WAITING_RESPONSE',
    FOLLOW_UP = 'FOLLOW_UP',
    DONE = 'DONE',
    REJECTED = 'REJECTED',
    ARCHIVED = 'ARCHIVED'
}

